export const getKey = (courseId: string) => ['tests', `course-${courseId}`];
